if (!customElements.get('new-make-spirit-article')) {
  customElements.define(
    'new-make-spirit-article',
    class NewMakeSpiritArticle extends HTMLElement {
      connectedCallback() {
        this.progress = this.querySelector('[data-nms-progress]');
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
        this.loadBottlesIfNeeded();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }

      onScroll() {
        const header =
          document.querySelector('#shopify-section-header .header') || document.querySelector('store-header');
        if (header) {
          const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
          this.style.setProperty('--nms-header-end', `${bottom}px`);
        }

        const start = this.offsetTop;
        const height = this.offsetHeight - window.innerHeight;
        const value = height > 0 ? Math.min(1, Math.max(0, (window.scrollY - start) / height)) : 0;
        if (this.progress) this.progress.style.width = `${value * 100}%`;
      }

      productImage(product) {
        const image = product.featured_image || product.image;
        if (!image) return '';
        if (typeof image === 'string') return image;
        return image.url || image.src || '';
      }

      formatCents(cents, format) {
        const major = Number(cents) / 100;
        if (Number.isNaN(major)) return '';
        const amount = major.toFixed(2);
        const pattern = format || '£{{amount}}';
        return pattern
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(major)))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
          .replace(/\{\{\s*amount\s*\}\}/g, amount);
      }

      sellingVariant(product) {
        const variants = product.variants || [];
        return variants.find((variant) => variant.available) || variants[0] || null;
      }

      productHandle(match) {
        if (match.handle) return match.handle;
        const path = String(match.url || '').split('?')[0];
        const handle = path.split('/products/')[1];
        return handle ? decodeURIComponent(handle) : '';
      }

      matches(product, slot) {
        const title = (product.title || '').toLowerCase();
        const keyword = (slot.dataset.nmsKeyword || '').toLowerCase();
        const abv = (slot.dataset.nmsAbv || '').toLowerCase();
        if (keyword && !title.includes(keyword)) return false;
        if (abv && !title.replace('%', '').includes(abv)) return false;
        if (!title.includes('soho')) return false;
        return Boolean(keyword && abv);
      }

      renderTile(slot, product, moneyFormat) {
        const variant = this.sellingVariant(product);
        const image = this.productImage(product);
        const rootUrl = window.Shopify?.routes?.root || '/';
        const href = product.url || `${rootUrl}products/${product.handle}`;
        const card = document.createElement('a');
        card.className = 'nms-tile';
        card.href = href;
        card.setAttribute('data-nms-product', '');

        const media = document.createElement('div');
        media.className = 'nms-tile__media';
        if (image) {
          const img = document.createElement('img');
          img.src = image;
          img.alt = product.title || '';
          media.appendChild(img);
        }

        const body = document.createElement('div');
        body.className = 'nms-tile__body';
        const heading = document.createElement('h3');
        heading.className = 'nms-tile__title';
        heading.textContent = product.title || '';
        const price = document.createElement('p');
        price.className = 'nms-tile__price';
        const cents = variant ? variant.price : product.price;
        price.innerHTML = this.formatCents(cents, moneyFormat);
        body.append(heading, price);
        card.append(media, body);
        slot.hidden = false;
        slot.appendChild(card);
      }

      async loadProduct(handle) {
        const rootUrl = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootUrl}products/${encodeURIComponent(handle)}.js`);
        if (!response.ok) return null;
        return response.json();
      }

      async loadBottlesIfNeeded() {
        const slots = Array.from(this.querySelectorAll('[data-nms-slot]')).filter(
          (slot) => !slot.querySelector('[data-nms-product]')
        );
        if (!slots.length) return;

        const configEl = this.querySelector('[data-nms-search-config]');
        let moneyFormat = '£{{amount}}';
        if (configEl) {
          try {
            moneyFormat = JSON.parse(configEl.textContent).moneyFormat || moneyFormat;
          } catch (error) {
            moneyFormat = '£{{amount}}';
          }
        }

        const rootUrl = window.Shopify?.routes?.root || '/';
        await Promise.all(
          slots.map(async (slot) => {
            const query = slot.dataset.nmsQuery;
            if (!query) return;
            try {
              const url = `${rootUrl}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`;
              const response = await fetch(url);
              if (!response.ok) return;
              const data = await response.json();
              const products = data?.resources?.results?.products || [];
              const match = products.find((product) => this.matches(product, slot));
              const handle = match ? this.productHandle(match) : '';
              if (!handle) return;
              const product = await this.loadProduct(handle);
              if (product) this.renderTile(slot, product, moneyFormat);
            } catch (error) {
              // Search is a fallback until the bottles resolve through the product handles.
            }
          })
        );
      }
    }
  );
}
